import { ComponentManager, DataTransferObject } from "radpresentation.htmlclient.defaultviewextensions";

export default class WFEOperationDTO extends DataTransferObject {

    public Title: KnockoutObservable<string>;

    public IsControlFlowOperation: KnockoutObservable<boolean>;

    public TaskPDO_ID: KnockoutObservable<string>;

    public IconUrl: KnockoutObservable<string>;

    public MethodName: KnockoutObservable<string>;

    public Description: KnockoutObservable<string>;

    public ShortDescription: KnockoutObservable<string>;


    public constructor() {
        super({
            xmlProperties: ['Title', 'IsControlFlowOperation', 'TaskPDO_ID', 'Icon', 'MethodName', 'Description', 'ShortDescription'],
            xmlNamespace: 'WorkflowEngine'
        });

        this.Title = this.observableOrDefault(this.defaultFromType('string'));
        this.IsControlFlowOperation = this.observableOrDefault(this.defaultFromType('bool'));
        this.TaskPDO_ID = this.observableOrDefault(this.defaultFromType('int'));
        this.IconUrl = this.observableOrDefault(this.defaultFromType('string'));
        this.MethodName = this.observableOrDefault(this.defaultFromType('string'));
        this.Description = this.observableOrDefault(this.defaultFromType('string'));
        this.ShortDescription = this.observableOrDefault(this.defaultFromType('string'));
    }
}

ComponentManager.setModel('WFEOperationDTO', WFEOperationDTO, 'WorkflowEngineHTMLViewExtension');